import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

Swiper.use([Navigation]);

export function initCommunityPhotoSlideShows() {
    const slideshowEls = document.querySelectorAll<HTMLElement>(
        '.js-community-slideshows',
    );

    const getAnimationType = () => {
        const width = window.innerWidth;
        if (width < 1024) return 'tablet'; // Tablet Down
        return 'desktop'; // Desktop
    };

    const slidesPer = getAnimationType() === 'tablet' ? 1 : 1.5;
    
    slideshowEls.forEach(swiperElement => {
        const parentElement = swiperElement.closest(
            '.js-community-slideshow-container',
        )!;
        const options: SwiperOptions = {
            slidesPerView: slidesPer, // Show a portion of the next and previous slides
            centeredSlides: true,
            spaceBetween: 10,
            loop: true,
            slideToClickedSlide: true,
            navigation: {
                nextEl: parentElement.querySelector(
                    '.js-btn-slideshow-next',
                ) as HTMLElement,
                prevEl: parentElement.querySelector(
                    '.js-btn-slideshow-prev',
                ) as HTMLElement,
            },
        };

        const swiper = new Swiper(swiperElement, options);
        swiper.update();
    });
}
